(() => {
  const passwordSection = document.getElementById('password-section');
  if (!passwordSection) return;

  const productContent = document.querySelector('[after-password]') || document.querySelector('.product-with-password');
  const errorMessage = document.getElementById('error-message');
  const form = document.getElementById('password-check');
  const submitButton = document.getElementById('submit-password');
  const campaign = form ? form.getAttribute('data-campaign') : '';
  const endpoint = 'https://career-ct.shopify-plugin.devbdd.com/check-password';

  const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  };

  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const parts = document.cookie.split(';');
    for (let i = 0; i < parts.length; i += 1) {
      let c = parts[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  };

  const postPassword = (password) => {
    const body = new URLSearchParams();
    body.append('password', password || '');
    body.append('campaign', campaign || '');
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body,
    }).then((res) => res.json());
  };

  const savedPassword = getCookie('pass_campaign');
  postPassword(savedPassword)
    .then((result) => {
      if (result && result.status == 200) {
        if (productContent) {
          productContent.style.display = '';
          productContent.style.opacity = '1';
        }
        passwordSection.remove();
      } else {
        passwordSection.style.display = '';
        if (productContent) productContent.remove();
      }
    })
    .catch(() => {
      passwordSection.style.display = '';
    });

  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (errorMessage) errorMessage.style.display = 'none';
      if (submitButton) {
        submitButton.textContent = 'Please wait..';
        submitButton.setAttribute('disabled', 'disabled');
      }

      const userInput = document.getElementById('password-input');
      postPassword(userInput ? userInput.value : '')
        .then((result) => {
          window.setTimeout(() => {
            if (submitButton) {
              submitButton.textContent = 'Submit';
              submitButton.removeAttribute('disabled');
            }
            if (result && result.status == 200) {
              setCookie('pass_campaign', userInput ? userInput.value : '', 1);
              window.location.reload();
            } else if (errorMessage) {
              errorMessage.style.display = '';
            }
          }, 500);
        })
        .catch(() => {
          if (submitButton) {
            submitButton.textContent = 'Submit';
            submitButton.removeAttribute('disabled');
          }
        });
    });
  }
})();
